
import axios from "axios";
import { BASE_API_ENDPOINT, glocalRefreshTokenUrl, ROOT_URL } from "../config/constant";

const axiosServices = axios.create({
  baseURL: BASE_API_ENDPOINT,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

axiosServices.interceptors.request.use(
  config => {
    const token = config.url.includes(BASE_API_ENDPOINT) ? sessionStorage.getItem("token") :  sessionStorage.getItem("accessToken") ;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  err => Promise.reject(err)
);

axiosServices.interceptors.response.use(
  response => response,
  error => {
    const { config, response } = error;
    const originalRequest = config;
    if (response?.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return axiosServices(originalRequest);
          })
          .catch(err => Promise.reject(err));
      }
      isRefreshing = true;
      const refreshToken = sessionStorage.getItem("refreshToken");
      if (!refreshToken) {
        sessionStorage.clear();
        window.location.href = ROOT_URL;
        return Promise.reject(error);
      }
      return new Promise(async (resolve, reject) => {
        try {
          const {
            data: {
              data: { id_token, access_token }
            }
          } = await axios.post(
            `${glocalRefreshTokenUrl}`,
            {
              refresh_token: sessionStorage.getItem("refreshToken")
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("accessToken")}` 
              }
            }
          );
          sessionStorage.setItem("token", id_token);
          sessionStorage.setItem("accessToken", access_token);
          processQueue(null, (originalRequest.url.includes(BASE_API_ENDPOINT) ? id_token :  access_token));
          originalRequest.headers["Authorization"] = "Bearer " + (originalRequest.url.includes(BASE_API_ENDPOINT) ? id_token :  access_token) ;
          resolve(axiosServices(originalRequest));
        } catch (err) {
          processQueue(err, null);
          sessionStorage.clear();
          window.location.href = ROOT_URL;
          reject(err);
        } finally {
          isRefreshing = false;
        }
      });
    }
    return Promise.reject((error.response && error.response.data) || error);
  }
);

export default axiosServices;
